/*
 * @Author: Nanxing Xiang
 * @LastEditors: Nanxing Xiang
 * @Date: 2020-04-29 10:11:18
 * @LastEditTime: 2021-03-15 17:22:52
 * @Description:
 * @FilePath: \easylive-download\src\config\config.online.ts
 */

import domains from './domains';

const onlineConfig: Omit<Config, 'apps'> = {
  api: {
    activity: '/v2/agservice/activity',
    appgw: '/appgw/v2',
    h5: '/h5',
    service: '/v2/agservice/service'
  },
  url: {
    DOWNLOAD_URL: `https://d.${domains.DOWNLOAD_DOMAIN}/download`
  }
};

export default onlineConfig;
